import { ErrorType } from "../../common/constants";
import Error from "../Error/Error";

const PageNotFound = () => {
  return (
    <div style={{ height: "100vh" }}>
      <Error type={ErrorType.NOT_FOUND} />
    </div>
  );
};

export default PageNotFound;
